import { NO, UITextView, UIView, YES } from "uicore-ts"
import { RHButton } from "../Custom components/RH/RHButton"
import { RHButtons } from "../Custom components/RH/Utils_slop/RHDesignTokens"

export type RHProcurementExcelExportButtonState = "generate" | "loading" | "locked"

export class ProcurementExcelExportButtonView extends UIView {
    
    static ICON_EXCEL(size = RHButtons.excelExportIconSize): string {
        return `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.15" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
  <path d="M6 3h8l4 4v14H6z"/>
  <path d="M14 3v5h5"/>
  <path d="M8.5 11.5h7"/>
  <path d="M8.5 15h7"/>
  <path d="M11 10v7"/>
</svg>`
    }
    
    readonly button = new RHButton()
        .configuredWithObject({
            titleLabel: {
                text: ProcurementExcelExportButtonView.ICON_EXCEL(),
                fontSize: RHButtons.excelExportIconSize,
                style: {
                    whiteSpace: "nowrap"
                }
            },
            contentPadding: RHButtons.excelExportContentPadding,
            style: {
                padding: "0px",
                borderRadius: "6px"
            }
        })
        .addedAsSubviewToView(this)
    
    private _state: RHProcurementExcelExportButtonState = "generate"
    private _fileName = ""
    
    exportWasRequested?: () => void
    
    constructor(elementID?: string) {
        super(elementID)
        
        this.button.contentPadding = RHButtons.excelExportContentPadding
        this.button.titleLabel.isSingleLine = YES
        this.button.titleLabel.textAlignment = UITextView.textAlignment.center
        
        // noinspection JSConstantReassignment
        this.button.controlEventTargetAccumulator.PrimaryActionTriggered = () => {
            if (this._state !== "loading") {
                this.exportWasRequested?.()
            }
        }
        
        this.configure("generate")
    }
    
    configure(state: RHProcurementExcelExportButtonState, fileName = "") {
        this._state = state
        this._fileName = fileName
        
        if (state === "loading") {
            this.button.variant = RHButtons.excelExportLoadingVariant
            this.button.titleLabel.text = "..."
            this.button.hoverText = "Väljundit genereeritakse"
            this.button.enabled = NO
        }
        else if (state === "locked") {
            this.button.variant = RHButtons.excelExportGenerateVariant
            this.button.titleLabel.text = ProcurementExcelExportButtonView.ICON_EXCEL()
            this.button.hoverText = "Avamisprotokolli saab koostada pärast pakkumuste esitamise tähtaega"
            this.button.enabled = YES
        }
        else {
            this.button.variant = RHButtons.excelExportGenerateVariant
            this.button.titleLabel.text = ProcurementExcelExportButtonView.ICON_EXCEL()
            if (fileName) {
                this.button.hoverText = `Lae alla ${fileName}`
            }
            else {
                this.button.hoverText = "Koosta avamise protokoll"
            }
            this.button.enabled = YES
        }
        
        this.button.titleLabel.fontSize = RHButtons.excelExportIconSize
        this.button.updateContentForCurrentState()
        this._applyStateStyle()
        this.setNeedsLayout()
    }
    
    private _applyStateStyle() {
        if (this._state === "locked") {
            this.button.configureWithObject({
                alpha: RHButtons.excelExportDisabledOpacity,
                style: {
                    filter: RHButtons.excelExportDisabledFilter,
                    cursor: RHButtons.excelExportDisabledCursor
                }
            })
        }
        else {
            let cursor = "pointer"
            if (this._state === "loading") {
                cursor = "default"
            }
            this.button.configureWithObject({
                alpha: 1,
                style: {
                    filter: "",
                    cursor
                }
            })
        }
    }
    
    
    override layoutSubviews() {
        super.layoutSubviews()
        
        this.button.frame = this.contentBoundsWithInset(0)
            .rectangleWithWidth(RHButtons.excelExportButtonSize, 0.5)
            .rectangleWithHeight(RHButtons.excelExportButtonSize, 0.5)
    }
    
    override intrinsicContentWidth(constrainingHeight?: number) {
        return RHButtons.excelExportButtonSize
    }
    
    override intrinsicContentHeight(constrainingWidth?: number) {
        return RHButtons.excelExportButtonSize
    }
    
}
